import { PropsWithChildren } from 'react';
import { styled, Typography } from '@mui/material';

const StatusTextStyled = styled('span')({
  textTransform: 'capitalize',
});

export default function StatusText({ children }: PropsWithChildren) {
  return (
    <Typography variant="body2">
      <StatusTextStyled>{children}</StatusTextStyled>
    </Typography>
  );
}
